import Helpers from '@Apis/helpers';
import Constants from '@Apis/constants';

/**
 * @param orgId
 */
class ReservationService {
  /**
   *
   * @param payload
   * @return {Promise<*>}
   */
  createReservation = async (payload) => {
    const createdReservation = await Helpers.post({
      url: Constants.RESERVATION,
      data: payload,
    });
    return createdReservation;
  };

  /**
   * @param orgId
   * @param page
   * @param limit
   * @param isActive
   * @param taxName
   * @param gstName
   * @return {Promise<*>}
   */
  getReservation = async (entityLineType, entityLineId, tenantProductId) => {
    let url = `${Constants.RESERVATION}?`;
    if (entityLineType) url += `reservation_entity_line_name=${entityLineType}&`;
    if (entityLineId) url += `reservation_entity_line_id=${entityLineId}&`;
    if (tenantProductId) url += `tenant_product_id=${tenantProductId}&`;

    const reservation = await Helpers.get({ url });
    return reservation;
  };

  /**
   * @param payload
   * @return {Promise<*>}
   */
  updateFreeReservation = async (payload) => {
    const updateFreeReservation = await Helpers.put({
      url: `${Constants.RESERVATION}/free`,
      data: payload,
    });
    return updateFreeReservation;
  };
}
export default new ReservationService();
